import { render, staticRenderFns } from "./RunInit.vue?vue&type=template&id=0aacb32a&scoped=true&"
import script from "./RunInit.vue?vue&type=script&lang=js&"
export * from "./RunInit.vue?vue&type=script&lang=js&"
import style0 from "./RunInit.vue?vue&type=style&index=0&id=0aacb32a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aacb32a",
  null
  
)

export default component.exports